export default __webpack_public_path__ + "static/media/Easelle_surealism.09d6fa06.png";